import {createEffectFn} from '@ngneat/effects';
import {catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap} from 'rxjs';
import {JobsInvoiceState} from '@store/invoices/jobsInvoice/jobsInvoice.store';
import {jobsInvoiceService} from '@store/invoices/jobsInvoice/jobsInvoice.service';

type SearchJobsInvoiceParams = Partial<JobsInvoiceState>

export const searchJobsInvoiceEffect = createEffectFn((params$: Observable<SearchJobsInvoiceParams>) => {
  return params$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(() => jobsInvoiceService.getJobsInvoice().pipe(catchError(() => EMPTY))),
  );
});
